import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ypsl",
  "use": "icon-ypsl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-ypsl\"><path d=\"M628.7 26.6h-231c-28.3 0-51 24.7-51 55.1 0 30.5 22.7 55.3 51 55.3h232.4c26.9 0 49.6-24.7 49.6-55.3 0-30.5-22.6-55.1-51-55.1z m134 55.4c0 71.8-13.2 110.8-83.1 110.8H347.1c-69.6 0-83.1-51.3-83.1-110.8H153.1C106.4 82 70 116.1 70 165.1v748.1c0 54.9 29.9 83.1 83.1 83.1h720.4c44.4 0 83.1-27.1 83.1-83.1V165.1c0-54.1-31-83.1-83.1-83.1H762.7z m-27.2 692.6H296.6c-16.2 0-32.3-16.6-32.3-30.1s13.7-25.1 29.8-25.1h437.6c16.2 0 29.8 10.5 31.1 25.1 0.1 13.5-11.1 30.1-27.3 30.1z m-5.8-194.2H290.1c-16.2 0-26.5-14.5-26.5-28.1 0-13.5 13.7-27.1 29.9-27.1h438.4c16.2 0 29.9 12.6 31.1 27.1 0 13.6-17.1 28.1-33.3 28.1z m0-193.9H290.1c-16.2 0-26.5-14.5-26.5-28.1 0-13.6 13.7-27.1 29.9-27.1h438.4c16.2 0 29.9 12.6 31.1 27.1 0 13.6-17.1 28.1-33.3 28.1z m0 0\" p-id=\"8431\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ypsl.svg
// module id = sQAv
// module chunks = 42